/** biome-ignore-all lint/a11y/noStaticElementInteractions: fix accessibility props*/
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: no click on div */

import {AllFonts} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/AllFonts/AllFonts';
import {useRecentlyUsedFonts} from '~/common/FabricInvitation/EventCreateDesign/FontProvider';
import {Typography} from '~library/atoms/Typography';
import {FontCategoryPills} from '../FontCategoryPills/FontCategoryPills';
import {RecentlyUsedFonts} from '../RecentlyUsedFonts/RecentlyUsedFonts';

import './FontsDropdown.sass';

export const FontsDropdown = ({onChange, selectedFont, recentlyUsedFonts}) => {
  const {selectedCategories, setSelectedCategories, categoryFonts, setCategoryFonts} =
    useRecentlyUsedFonts();

  return (
    <div className="fonts__desktop">
      <div className="fonts__desktop-dropdown">
        <div className="fonts__desktop-header">
          <FontCategoryPills
            selectedCategories={selectedCategories}
            setCategoryFonts={setCategoryFonts}
            setSelectedCategories={setSelectedCategories}
          />
        </div>
        {recentlyUsedFonts.filter((obj) => Object.keys(obj).length).length > 0 &&
          selectedCategories.length < 1 && (
            <>
              <Typography
                as="h1"
                variant="label2"
                semibold="true"
                color="pebble"
                className="fonts__desktop-title"
              >
                Recently Used
              </Typography>
              <div className="fonts__desktop-recent">
                <RecentlyUsedFonts
                  onClick={onChange}
                  recentlyUsedFonts={recentlyUsedFonts}
                  selectedFont={selectedFont}
                />
              </div>
            </>
          )}

        {selectedCategories.length > 0 ? (
          selectedCategories.map((selectedCategory) => (
            <div className="fonts__desktop-font-families" key={selectedCategory}>
              <Typography
                as="h1"
                variant="label2"
                semibold="true"
                color="pebble"
                className="fonts__desktop-title"
              >
                {selectedCategory} (
                {categoryFonts[selectedCategory]?.length
                  ? categoryFonts[selectedCategory].reduce((total, font) => {
                      const fontVariations = font.styles.length * font.weights.length;
                      return total + fontVariations;
                    }, 0)
                  : 0}
                )
              </Typography>
              <div className={`fonts__desktop-category`}>
                <AllFonts
                  onClick={onChange}
                  selectedFont={selectedFont}
                  allFonts={categoryFonts[selectedCategory]}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="fonts__desktop-font-families">
            <Typography
              as="h1"
              variant="label2"
              semibold="true"
              color="pebble"
              className="fonts__desktop-title"
            >
              All fonts (
              {window.fonts.reduce((total, font) => {
                const fontVariations = font.styles.length * font.weights.length;
                return total + fontVariations;
              }, 0)}
              )
            </Typography>
            <div className="fonts__desktop-all">
              <AllFonts onClick={onChange} selectedFont={selectedFont} allFonts={window.fonts} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
